import { useQuery } from '@tanstack/react-query';
import { workLogKeys } from '@/entities/work-log';
import { fetchTodayWorkLog } from '../api';

export function useTodayWorkLogQuery(userId: string | undefined) {
  return useQuery({
    queryKey: workLogKeys.today(userId),
    queryFn: () => fetchTodayWorkLog(),
    enabled: !!userId,
    staleTime: 30_000,
  });
}
